{
  "features": {
    "filePreview": {
      "measurements": {
        "label": "Measured shapes on this page",
        "show": "Show measurements",
        "unlabelled": "Unlabelled",
        "count": "{count, plural, one {# shape} other {# shapes}}",
        "measured": "Measured: {total}"
      }
    },
    "scopeBreakdown": {
      "title": "Scope breakdown",
      "frame": {
        "none": "Volve reads every tender file into a sheet in your standard",
        "running": "Writing the scope breakdown",
        "failed": "The last run failed",
        "partial": "Partly written. Update to finish",
        "ready": "Your standard's scope breakdown, as a sheet",
        "unavailable": "Being updated"
      },
      "page": {
        "no-documents": {
          "title": "No documents to read",
          "description": "Upload the tender's documents, or retry the ones that could not be analyzed.",
          "action": "Go to files"
        },
        "preparing": {
          "title": "Preparing the documents",
          "description": "You can run the scope breakdown once the tender's documents are analyzed."
        },
        "empty": {
          "title": "No scope breakdown yet",
          "description": "Volve reads every tender file and writes the scope breakdown as a sheet, in the standard you choose."
        },
        "running": {
          "title": "Starting the run",
          "description": "The sheet appears here once the run creates it and fills as Volve reads the files."
        },
        "unavailable": {
          "title": "Scope breakdown is being updated",
          "description": "The new scope breakdown is not available yet. Try again after the update."
        },
        "failed": {
          "title": "Could not load document status",
          "description": "Try again to check whether the documents are ready.",
          "action": "Try again"
        }
      },
      "runAlert": {
        "failed": {
          "title": "The last run failed",
          "run": "The run's sheet is not used for work packages. Run again to start over.",
          "update": "The sheet keeps what the update wrote before it stopped. Update again to continue.",
          "reasons": {
            "time_limit": "The run reached its time limit before writing a row.",
            "allowance": "The run used up its model calls before writing a row.",
            "answer_refused": "The run's answer did not account for every tender file, and it stopped before writing a row.",
            "agent_failed": "The agent stopped before writing a row.",
            "no_standard": "The run names no structure. Choose one and run again.",
            "expired": "The run stopped responding and was ended.",
            "crashed": "The run stopped on an internal error."
          }
        },
        "partial": {
          "title": "The last run did not finish everything",
          "description": "{count, plural, =0 {It stopped before the end. Update continues from the sheet.} one {It left # file unread. Update reads it and continues from the sheet.} other {It left # files unread. Update reads them and continues from the sheet.}}",
          "notRead": "Not read"
        }
      },
      "run": {
        "run": "Run",
        "update": "Update",
        "runDescription": "Volve reads every tender file and writes the scope breakdown as a sheet, in the structure you choose. It runs in the background, so you can leave this page.",
        "updateDescription": "Volve edits the current sheet and keeps its structure. Statuses, comments, tasks and manual edits stay. Only the files added since the last run and the files it left open are read.",
        "startNew": "Start a new sheet",
        "startNewDescription": "The current sheet, with its statuses, comments and tasks, stays in the library. The new sheet replaces it for work packages when its run is done.",
        "structure": "Structure",
        "structures": {
          "library": {
            "title": "Standard from your library",
            "description": "A standard in your organization's knowledge bases, such as a description standard or a measurement standard. Volve also reads your other standards for the general parts it relies on."
          },
          "volve": {
            "title": "Volve work packages",
            "description": "Volve's work package templates for the project type."
          },
          "template": {
            "title": "Your template",
            "description": "Tender files that hold your template, such as an Excel sheet or a PDF with a sample layout."
          },
          "tender_bill": {
            "title": "The tender's own bill",
            "description": "The client's bill or scope description: its items, codes and order."
          }
        },
        "standards": "Standards",
        "uploadStandard": "Upload standard or template",
        "standardPreparing": "Preparing your standard. It will be selected automatically when ready.",
        "standardFailed": "This standard could not finish preparing. Retry or continue without it.",
        "retryStandard": "Retry preparation",
        "skipStandard": "Continue without this standard",
        "standardsDescription": "Choose a technical standard, specification system, handbook or template. Uploads are saved in your library for reuse.",
        "noStandards": "No standards are ready yet. Upload a standard or template to get started.",
        "instructions": "Instructions",
        "instructionsPlaceholder": "e.g. only interior walls; fill quantities from the room schedules; one post per treatment",
        "instructionsUpdatePlaceholder": "e.g. measure quantities for tab Doors",
        "instructionsDescription": "Optional. Volve follows them beside the structure.",
        "files": "Tender files",
        "noFiles": "The tender has no files yet. Upload the template.",
        "upload": "Upload",
        "pickStructure": "Choose a structure",
        "pickStandard": "Pick at least one knowledge base that holds the standard",
        "pickFiles": "Pick at least one tender file for the template",
        "refused": {
          "preparing": "The tender's documents are still being prepared. Try again when they are ready.",
          "noDocuments": "The tender has no documents yet. Upload them first.",
          "noSheet": "There is no sheet to update. Start a new sheet instead."
        },
        "genericError": "An error occurred, please try again later"
      },
      "outline": {
        "tree": "Codes",
        "search": "Search code or text",
        "posts": "Posts",
        "postCount": "{count, plural, one {# post} other {# posts}}",
        "allPackages": "All packages",
        "markers": {
          "inPackage": "In this package",
          "input": "Needs input",
          "assumed": "Has assumptions",
          "interface": "Interface or overlap",
          "empty": "Empty code",
          "orienting": "Orienting text"
        },
        "states": {
          "stated": "Stated in the documents",
          "assumed": "Assumed value",
          "input": "Needs input",
          "unsourced": "No source"
        },
        "expand": "Expand",
        "collapse": "Collapse",
        "noMatches": "No codes or rows match",
        "empty": "This sheet has no scope rows yet",
        "openSource": "Open source",
        "assign": "Assign",
        "move": "Move",
        "moveToCode": "Move to code",
        "chapterEnd": "Chapter, at the end",
        "package": "Package",
        "discipline": "Discipline",
        "exclude": "Exclude",
        "include": "Include again",
        "excluded": "Excluded",
        "task": "Task",
        "quotePage": "p. {page}",
        "flagsAssumptions": "{count, plural, one {# assumption} other {# assumptions}}",
        "flagsInputs": "{count, plural, one {# needs input} other {# need input}}",
        "legendLines": "Rows",
        "noValue": "—",
        "sourceCount": "{count, plural, one {# source} other {# sources}}",
        "assumed": "Assumed",
        "introduction": "Introduction",
        "orienting": {
          "label": "Orienting text",
          "hint": "Tender conditions that affect the prices below; not priced themselves.",
          "more": "+{count}",
          "showAll": "Show all {count}",
          "showLess": "Show less",
          "add": "Add condition",
          "addPlaceholder": "The condition, in the tender's words",
          "addSave": "Add",
          "cancel": "Cancel",
          "addedByYou": "Added by you",
          "comment": "Comment",
          "restore": "Restore",
          "marker": "{count, plural, one {# orienting text} other {# orienting texts}}",
          "recheck": "Conditions changed · Re-check posts",
          "recheckIntro": "The orienting text under {heading} in tab {tab} changed. Re-check the posts below it and adjust their scope and quantities where the change affects them:",
          "changes": {
            "added": "Added",
            "excluded": "Excluded",
            "restored": "Restored"
          }
        },
        "applies": {
          "label": "Applies here",
          "hint": "Inherited from the headings above. Edit at the heading.",
          "fromGroup": "from {code} · this group",
          "fromTrade": "from {code} · all posts",
          "goToHeading": "Go to heading",
          "showMore": "Show {count} more",
          "showLess": "Show less"
        },
        "edit": {
          "confirm": "Confirm",
          "edit": "Edit",
          "save": "Save",
          "cancel": "Cancel",
          "number": "Not a number",
          "option": "Not one of the options",
          "remeasure": "Re-measure this post",
          "remeasureInstruction": "Re-measure the quantity of post {post} in tab {tab}: {field} is now {value}."
        },
        "suggestedChanges": "Suggested changes",
        "suggestedField": "Suggested {field}",
        "clearSuggestedValue": "Clear this value",
        "acceptSuggestion": "Accept suggestion",
        "dismissSuggestion": "Keep my value",
        "suggestionCount": "{count, plural, one {# suggested change} other {# suggested changes}}"
      },
      "openCurrentSheet": "Open current sheet",
      "beta": "Beta"
    },
    "sheets": {
      "empty": "This sheet has no tabs yet",
      "editorUnavailable": "Live editing is unavailable. Showing the last saved version.",
      "review": "Review",
      "inputErrors": {
        "number": "Enter a number",
        "option": "Choose one of the column options",
        "reference": "References come from the agent and cannot be typed"
      },
      "unknownDocument": "Document",
      "page": "Page {page}",
      "columnTypes": {
        "text": "Text",
        "number": "Number",
        "enum": "Choice",
        "date": "Date",
        "reference": "Reference"
      },
      "save": "Save",
      "rowNumber": "Row {number}",
      "undo": "Undo",
      "redo": "Redo",
      "download": "Download (.xlsx)",
      "downloadError": "Could not download the sheet. Try again.",
      "tabFallback": "Tab {number}",
      "openRow": "Open row details and comments",
      "editRefused": "The change was not made",
      "unsavedRow": "Not saved",
      "unsavedRowDescription": "Save new rows before you review them or create tasks for them",
      "saveRows": "Save {count, plural, one {new row} other {# new rows}}",
      "saveError": "Could not save the sheet. Try again.",
      "sources": "Sources",
      "sheetInScopeBreakdown": "This sheet is the scope breakdown",
      "sheetInScopeBreakdownDescription": "View and edit it in the workspace's scope breakdown.",
      "openScopeBreakdown": "Open scope breakdown"
    }
  }
}
